// Blog metadata for the listing page + per-article pages
import costCover from "./assets/blog/cost-bmw-csl-exo.jpg";
import bestCover from "./assets/blog/best-urus-yellow.jpg";
import ppfCover from "./assets/blog/vs-ppf-qx80.jpg";

export const BLOG_POSTS = [
  {
    slug: "ceramic-coating-cost-mississauga-2026",
    title: "How Much Does Ceramic Coating Cost in Mississauga? (2026 Guide)",
    description:
      "A transparent breakdown of ceramic coating prices in Mississauga in 2026. what $200, $550 and $1,500+ packages actually include, and how to spot the cheap-coating traps.",
    tldr:
      "Real ceramic coating in Mississauga costs $550-$2,000 depending on size, prep and warranty. $199 'specials' are usually paste waxes. not real ceramic.",
    date: "2026-04-15",
    readMin: 7,
    keywords: ["ceramic coating cost mississauga", "ceramic coating price 2026", "best ceramic coating mississauga"],
    cover: costCover,
    coverAlt: "Crystal Serum Light + EXO v5 product box held in front of a white BMW M4 inside Jester Werks Mississauga ceramic coating studio",
  },
  {
    slug: "best-ceramic-coating-mississauga",
    title: "The Best Ceramic Coating in Mississauga: A Buyer's Guide",
    description:
      "How to actually pick the best ceramic coating studio in Mississauga. what to ask, what to inspect, and the 8 red flags that separate real shops from $20-coating scams.",
    tldr:
      "The best ceramic coating studios are owner-operated, document the entire process, measure paint depth, and back the coating with a real written warranty.",
    date: "2026-03-30",
    readMin: 9,
    keywords: ["best ceramic coating mississauga", "ceramic coating shops mississauga", "ceramic coating reviews mississauga"],
    cover: bestCover,
    coverAlt: "Yellow Lamborghini Urus parked in the Jester Werks Mississauga ceramic coating studio after a 2-layer Crystal Serum Light + EXO v5 application",
  },
  {
    slug: "ceramic-coating-vs-ppf",
    title: "Ceramic Coating vs PPF (Paint Protection Film): Which Is Better in 2026?",
    description:
      "The honest comparison Mississauga drivers ask for: ceramic coating vs paint protection film. Cost, durability, gloss, scratch resistance, and which one to pick.",
    tldr:
      "PPF is better at stopping rock chips. Ceramic is better for gloss, easier washing, and 5+ years of UV/chemical protection. The smart play is often both. PPF the front, ceramic the rest.",
    date: "2026-02-20",
    readMin: 6,
    keywords: ["ceramic coating vs ppf", "paint protection film mississauga", "ceramic coating or ppf"],
    cover: ppfCover,
    coverAlt: "White Infiniti QX80 inside Jester Werks Mississauga studio after ceramic coating. gloss reflections under detailing studio lights",
  },
];
